import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ibgqpaqrzokjcegtlrzb.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_5iEds4rRnV5QL1En4A0x3w_RooOfuYL';

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn(
    'Using hardcoded Supabase fallback credentials. ' +
    'Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY env vars to override.'
  );
}

export const SUPABASE_URL = supabaseUrl;
export const SUPABASE_ANON_KEY = supabaseAnonKey;

// 'edge'   = all DB access goes through the trusted erp-api Edge Function
//            (browser never touches the DB; RLS can be locked down).
// 'direct' = legacy path: browser talks to Supabase with the anon key (default,
//            keeps current behavior until the Edge Function is deployed).
export const API_MODE = process.env.REACT_APP_API_MODE === 'edge' ? 'edge' : 'direct';
export const isEdgeMode = () => API_MODE === 'edge';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
